"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Title_1 = require("./Title");
Object.defineProperty(exports, "Title", { enumerable: true, get: function () { return Title_1.Title; } });
//# sourceMappingURL=index.js.map